// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".containerMap[data-v-6a07e99a]{text-align:center}.map[data-v-6a07e99a]{width:85vw;height:75vh;border:1px solid #000}.back[data-v-6a07e99a]:hover{color:#27846d!important;caret-color:#27846d!important}@media screen and (min-width:900px){.back[data-v-6a07e99a]{margin-left:85px}}@media screen and (min-height:800px){.loading[data-v-6a07e99a]{text-align:center;margin-top:250px}}@media screen and (max-height:800px){.loading[data-v-6a07e99a]{text-align:center;margin-top:140px}}", ""]);
// Exports
module.exports = exports;
